<financial-statement-filter [company]="company" [searchInput]="searchInput"
  (emmitSearch)="onSearch($event)"></financial-statement-filter>

<mat-card *ngIf="hasHolder() && !hasBeneficiaryList()" class="history-beneficiary">
  <h3 class="card-title">HISTÓRICO DE COMPRA</h3>
  <div class="table-container">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
      <ng-container matColumnDef="select" sticky>
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <mat-checkbox [(ngModel)]="element.selected" (change)="onSelectRow(element)"> </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef>Beneficiário</th>
        <td mat-cell *matCellDef="let element">
          <span class="beneficiary-type"
            [ngClass]="{ titular: element.title === 'Titular', dependente: element.title === 'Dependente' }">{{
            element.title
            }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Nome</th>
        <td mat-cell *matCellDef="let element">{{ element.name | uppercase }}</td>
      </ng-container>

      <ng-container matColumnDef="registration">
        <th mat-header-cell *matHeaderCellDef>Matrícula</th>
        <td mat-cell *matCellDef="let element">{{ element.registration ? element.registration : "-" }}</td>
      </ng-container>

      <ng-container matColumnDef="socialNumber">
        <th mat-header-cell *matHeaderCellDef>CPF</th>
        <td mat-cell *matCellDef="let element">{{ element.socialNumber | socialNumberFormatPipe }}</td>
      </ng-container>

      <ng-container matColumnDef="cardNumber">
        <th mat-header-cell *matHeaderCellDef>Cartão</th>
        <td mat-cell *matCellDef="let element">{{ element.cardNumber | cardNumberFormat }}</td>
      </ng-container>

      <ng-container matColumnDef="limit">
        <th mat-header-cell *matHeaderCellDef>
          Limite {{ beneficiaryLimitType === 0 ? "Individual" : beneficiaryLimitType === 1 ? "Familiar" : "Ilimitado" }}
        </th>
        <td mat-cell *matCellDef="let element">
          <span *ngIf="!isLimitLoading || element.limit">{{ element.limit | currencyPbmPipe }}</span>
          <mat-spinner diameter="20" *ngIf="isLimitLoading && !element.limit"></mat-spinner>
        </td>
      </ng-container>

      <ng-container matColumnDef="dependents">
        <th mat-header-cell *matHeaderCellDef>Dependentes</th>
        <td mat-cell *matCellDef="let element">{{ element.dependents ? element.dependents : "-" }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let element">
          <span class="value" matTooltip="Ativo" *ngIf="element.status">
            <mat-icon style="color: #2dcd7a">check_circle_outline</mat-icon>
            <span *ngIf="element.title === 'Titular'">Ativo</span>
          </span>
          <span class="value" matTooltip="Inativo" *ngIf="!element.status">
            <mat-icon style="color: gray">close</mat-icon>
            <span *ngIf="element.title === 'Titular'">Inativo</span>
          </span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</mat-card>
<mat-card *ngIf="hasHolder() && !hasBeneficiaryList()" class="resume-beneficiary" id="print-section">
  <div class="container-title">
    <h3 class="card-title">RESUMO DO CICLO ATUAL</h3>
    <button class="export-btn" mat-flat-button [disabled]="isLimitLoading"
      printTitle="PBM - Exportar Extrato de Beneficiários"
      styleSheetFile="assets/css/financial-statement-beneficiary.css" printSectionId="print-section"
      [matTooltip]="!isLimitLoading ? 'Exportar para PDF' : 'Aguarde enquanto carregamos todos os dados do extrato para exportação'"
      ngxPrint>
      <mat-icon aria-hidden="false">picture_as_pdf</mat-icon>
      {{ !isLimitLoading ? "Exportar p/ PDF" : "Carregando..." }}
    </button>
  </div>
  <div class="filters-components">
    <form [formGroup]="rootForm" class="filter-form">
      <div fxLayout="column" fxLayoutAlign="center start">
        <span class="title">Data de Apuração*</span>
        <mat-form-field appearance="outline" fxFlex="100">
          <mat-select class="select-field" required formControlName="months" multiple>
            <mat-option *ngFor="let date of dates" [value]="date"
              [disabled]="rootForm.get('months').value?.length >= 3 && !rootForm.get('months').value?.includes(date)">
              {{ date.getLabel() }}
            </mat-option>
          </mat-select>
          <mat-hint><small>Selecione até 3 meses</small></mat-hint>
        </mat-form-field>
      </div>
      <div fxLayout="column" fxLayoutAlign="center start">
        <span class="title">Rede</span>
        <select-auto-complete class="select-auto-field" [columnToDisplay]="'DisplayName'" [searchInput]="find"
          [selectionChange]="onSelectNetwork" [isLoading]="isLoadingNetwork" [labels]="{
                title: '',
                placeholder: 'Digite o nome ou CNPJ da rede',
                hint: 'Pesquisar por rede',
                row: 0,
              }" [template]="template" fxFlex="100">
        </select-auto-complete>
        <ng-template #template let-data="data">
          <div class="option-content" #content>
            <div fxFlexLayout="column">
              <div fxFlexLayout="row">
                <mat-icon>business</mat-icon>
                <span>{{ data.CorporateName }}</span>
              </div>
              <small>{{ data.FiscalNumber.Value | companyFederalNumber }} | {{ data.DisplayName }}</small>
            </div>
          </div>
        </ng-template>
      </div>
    </form>
    <div class="filter-button">
      <button mat-flat-button class="filter-btn" matTooltip="Filtrar" (click)="onFilterChange()">
        <mat-icon aria-hidden="false">filter_list</mat-icon>
        <span>Filtrar</span>
      </button>
    </div>
  </div>
  <div class="financial-statement-cards">
    <div class="financial-card">
      <h3 class="card-title">Beneficiários Selecionados ({{ selectedBeneficiaries.length }})</h3>
      <div class="total-expenses" *ngIf="totalBalance">
        <span class="label">Total Geral dos Gastos</span>
        <span class="value">{{ totalBalance | currencyPbmPipe }}</span>
      </div>
      <div *ngFor="let beneficiary of selectedBeneficiaries" class="beneficiary-selected">
        <div class="beneficiary-info">
          <div class="title">
            <p class="name">{{ beneficiary.name }}</p>
            <p class="detail">{{ beneficiary.title }}</p>
          </div>
          <div class="title-right">
            <p class="detail">Total Gasto</p>
            <mat-spinner diameter="20" *ngIf="isLimitLoading"></mat-spinner>
            <p
            *ngIf="!(isLimitLoading)"
             class="total" [style]="{ color: beneficiary.color }">{{ beneficiary.totalSpent | currencyPbmPipe }}</p>
          </div>
        </div>
        <mat-divider></mat-divider>
        <div class="beneficiary-details">
          <div class="content">
            <span class="label">Saldo disponível</span>
            <!-- Saldo disponível -->
            <span *ngIf="!(isLimitLoading) && (beneficiary.availableBalance != null)">
              {{ beneficiary.availableBalance | currencyPbmPipe }}
            </span>

            <mat-spinner diameter="20" *ngIf="isLimitLoading"></mat-spinner>

            <span *ngIf="!(isLimitLoading) && (beneficiary.availableBalance == null)">
              {{ beneficiary.limit != null ? (beneficiary.limit | currencyPbmPipe) : '-' }}
            </span>
          </div>
          <div class="content">
            <span class="label">Fechamento</span>
            <span *ngIf="!isLimitLoading || beneficiary.dueDate">{{ beneficiary.dueDate }}</span>
            <mat-spinner diameter="20" *ngIf="isLimitLoading && !beneficiary.dueDate"></mat-spinner>
          </div>
          <div class="content">
            <span class="label">Região</span>
            <span class="value">{{ beneficiary.region }}</span>
          </div>
          <div class="content">
            <span class="label">Total de Transações</span>
            <span class="value">{{ lengthFinancialStatement(beneficiary) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="table-container-resume">
    <table mat-table [dataSource]="financialStatementItems" class="mat-elevation-z8">
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef>Data</th>
        <td mat-cell *matCellDef="let element">{{ element.getDate() | date : "dd/MM/yyyy" }}</td>
      </ng-container>

      <ng-container matColumnDef="network">
        <th mat-header-cell *matHeaderCellDef>Local da Compra</th>
        <td mat-cell class="no-wrap" *matCellDef="let element">{{ element.getNetworkName() }}</td>
      </ng-container>

      <ng-container matColumnDef="beneficiary">
        <th mat-header-cell *matHeaderCellDef>Beneficiário</th>
        <td mat-cell *matCellDef="let element">
          <span class="name no-wrap"
            [style]="{ color: getColor(element.getBeneficiarySocialNumber()), 'background-color': getBackgroundColor(element.getBeneficiarySocialNumber()) }">{{
            element.getBeneficiaryName() }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="product">
        <th mat-header-cell *matHeaderCellDef>Produto</th>
        <td mat-cell class="no-wrap" *matCellDef="let element">{{ element.getProductName() }}</td>
      </ng-container>

      <ng-container matColumnDef="quantity">
        <th mat-header-cell *matHeaderCellDef>Qtde</th>
        <td mat-cell *matCellDef="let element">{{ element.getProductQuantity() }}</td>
      </ng-container>

      <ng-container matColumnDef="value">
        <th mat-header-cell *matHeaderCellDef>Valor</th>
        <td mat-cell *matCellDef="let element">{{ element.getUnitPrice() | currencyPbmPipe }}</td>
      </ng-container>

      <ng-container matColumnDef="discount">
        <th mat-header-cell *matHeaderCellDef>Desconto</th>
        <td mat-cell *matCellDef="let element">{{ element.getDiscountValue() | currencyPbmPipe }}</td>
      </ng-container>

      <ng-container matColumnDef="subsidy">
        <th mat-header-cell *matHeaderCellDef>Subsídio</th>
        <td mat-cell *matCellDef="let element">{{ element.getSubsidyValue() | currencyPbmPipe }}</td>
      </ng-container>

      <ng-container matColumnDef="deduction">
        <th mat-header-cell *matHeaderCellDef>Desc. em folha</th>
        <td mat-cell *matCellDef="let element">{{ element.getEmploymentPayrollValue() | currencyPbmPipe }}</td>
      </ng-container>

      <ng-container matColumnDef="paid">
        <th mat-header-cell *matHeaderCellDef>Valor Pago</th>
        <td mat-cell *matCellDef="let element">{{ element.getPrice() | currencyPbmPipe }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedResumeColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedResumeColumns"></tr>
    </table>
  </div>
</mat-card>
<div *ngIf="!hasHolder()" class="beneficiary-list-container">
  <div class="search-control">
    <p>{{ getResultQuantityPhrase() }}</p>
    <div *ngFor="let beneficiary of getBeneficiaries()">
      <div class="company-card">
        <div class="company-data">
          <div>
            <p class="company-name">{{ beneficiary.getName() }}</p>
            <p class="company-cnpj">CPF: {{ beneficiary.getSocialNumber() }}</p>
          </div>
          <p class="company-beneficiary-type">{{ beneficiary.getIsHolder() ? "Titular" : "Dependente" }}</p>
        </div>
        <div class="company-status">
          <div class="view-btn" (click)="goToBeneficiaryInfo(beneficiary)">
            <mat-icon aria-hidden="false">visibility</mat-icon>
            {{ "VISUALIZAR" }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>